// UpdateBankDetailsComponent.js
import React from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import styles from "./UpdateBankDetailsComponent.module.css";
import leftArrow from "../../../assests/leftArrow.svg";

const UpdateBankDetailsComponent = (props) => {
  const navigate = useNavigate();
  const goback = () => navigate(-1);

  return (
    <div className={styles.mainLayout}>
      <Sidebar />

      <div className={styles.bankPageContainer}>
        {/* ============ HEADER ============ */}
        <div className={styles.bankPageHeader}>
          <button
            className={styles.backButton}
            onClick={goback}
            type="button"
          >
            <img src={leftArrow} alt="Back" />
          </button>
          <div className={styles.titleBlock}>
            <h2 className={styles.pageTitle}>Edit Bank Details</h2>
            <p className={styles.pageSubtitle}>
              Update your bank account information
            </p>
          </div>
        </div>

        {/* ============ FULL-WIDTH WHITE CARD ============ */}
        <div className={styles.bankFormWrapper}>
          {/* Inner content wrapper */}
          <div className={styles.bankFormInner}>
            {/* Card Header */}
            <div className={styles.cardHeader}>
              <div className={styles.cardIconCircle}>
                <span>🏦</span>
              </div>
              <div className={styles.cardHeaderText}>
                <div className={styles.cardTitle}>Bank Information</div>
                <div className={styles.cardSubtitle}>
                  All fields are required
                </div>
              </div>
            </div>

            {/* Form Section */}
            <div className={styles.formSection}>
              <div className={styles.formSectionLabel}>
                Account Details
              </div>

              <div className={styles.bankForm}>
                <div className={styles.formField}>
                  <label className={styles.fieldLabel}>
                    Account Name <span className={styles.required}>*</span>
                  </label>
                  <TextField
                    fullWidth
                    placeholder="Enter account holder name"
                    name="accountName"
                    value={props.formDataBank?.accountName || ""}
                    onChange={props.handleChangeUpdateBankDetails}
                    variant="outlined"
                    size="small"
                    className={styles.inputField}
                  />
                </div>

                <div className={styles.formField}>
                  <label className={styles.fieldLabel}>
                    Account Number <span className={styles.required}>*</span>
                  </label>
                  <TextField
                    fullWidth
                    placeholder="Enter bank account number"
                    name="accountId"
                    value={props.formDataBank?.accountId || ""}
                    onChange={props.handleChangeUpdateBankDetails}
                    variant="outlined"
                    size="small"
                    className={styles.inputField}
                  />
                </div>

                <div className={styles.formField}>
                  <label className={styles.fieldLabel}>
                    IFSC Code <span className={styles.required}>*</span>
                  </label>
                  <TextField
                    fullWidth
                    placeholder="e.g. HDFC0001234"
                    name="ifsc"
                    value={props.formDataBank?.ifsc || ""}
                    onChange={props.handleChangeUpdateBankDetails}
                    variant="outlined"
                    size="small"
                    className={styles.inputField}
                  />
                </div>
              </div>
              
            </div>
             <div className={styles.bankButtons}>
            <Button
              variant="outlined"
              className={styles.cancelBtn}
              onClick={goback}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className={styles.saveBtn}
              onClick={props.handleUpdateBankDetails}
            >
              Save Changes
            </Button>
          </div>
          </div>

          {/* ============ ACTION BUTTONS ============ */}
         
        </div>
      </div>
    </div>
  );
};

export default UpdateBankDetailsComponent;